import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { Pages } from 'modules/navigation/domain/enums/pages';
import type { RootState } from 'store/store';
import { AuthRequestAuthCodePayload } from '../domain/interfaces/auth-request-auth-code-payload';
import { AuthRestorePayload } from '../domain/interfaces/auth-restore-payload';
import { AuthSignInPayload } from '../domain/interfaces/auth-sign-in-payload';
import { AuthCheckResponse } from '../domain/interfaces/auth-sign-in-response';
import { AuthSignUpPayload } from '../domain/interfaces/auth-sign-up-payload';
import { AuthSignUpErrorPayload, AuthSignUpResponse } from '../domain/interfaces/auth-sign-up-response';
import { AuthTempPasswordResponse } from '../domain/interfaces/auth-temp-password-response';
import authService from 'modules/auth/domain/services/auth-service';

const getHistory = () => require('store/store').history;

const PREFIX = 'auth';

const wait = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(() => resolve('ok'), ms);
  });

export const authRestore = createAsyncThunk<void, AuthRestorePayload>(`${PREFIX}/authRestore`, async () => {
  await wait(3000);
});

export const authSignIn = createAsyncThunk<void, AuthSignInPayload, { state: RootState }>(
  `${PREFIX}/authSignIn`,
  async (payload, { dispatch }) => {
    await authService.signIn(payload);
    dispatch(authCheck(payload.to));
    // const response = await authService.signIn(payload);
    // getHistory().push(Pages.INDEX);
  },
);

export const authRequestAuthCode = createAsyncThunk<AuthTempPasswordResponse, AuthRequestAuthCodePayload>(
  `${PREFIX}/authRequestAuthCode`,
  async (payload) => {
    return authService.requestAuthCode(payload);
  },
);

export const authSignOut = createAction(`${PREFIX}/authSignOut`, () => {
  authService.signOut();

  getHistory().push(Pages.SIGN_IN);

  return {
    payload: null,
  };
});

export const authSignUp = createAsyncThunk<AuthSignUpResponse, AuthSignUpPayload, { rejectValue: AuthSignUpErrorPayload }>(
  `${PREFIX}/authSignUp`,
  async (payload, { rejectWithValue }) => {
    try {
      return await authService.signUp(payload);
    } catch (err) {
      const data = (err as AxiosError<AuthSignUpErrorPayload>).response?.data;
      return rejectWithValue(data ?? { message: 'Ошибка регистрации' });
    }
  },
);

export const authCheck = createAsyncThunk<AuthCheckResponse | null, string | undefined, { state: RootState }>(
  `${PREFIX}/authCheck`,
  async (continueFrom) => {
    let result = null;

    try {
      result = await authService.check();
    } catch (err) {
      console.error('error', err);
    }

    if (!result) {
      getHistory().push(Pages.SIGN_IN, { to: continueFrom });
    } else if (result.user) {
      getHistory().push(continueFrom || Pages.INDEX);
    }

    return result;
  },
);

export const clearActiveTournamentId = createAction(`${PREFIX}/clearActiveTournamentId`);

export const switchUserTournament = createAction(`${PREFIX}/switchTournament`, (id: number) => {
  getHistory().push(Pages.INDEX);

  return {
    payload: id,
  };
});
